import React from 'react';
import {twMerge} from 'tailwind-merge';
import {cva} from 'class-variance-authority';
import clsx from 'clsx';

export const badgeClasses = clsx(
	'inline-flex items-center justify-center rounded px-1.5 py-0.5 gap-0.5 font-medium',
);

export const badgeVariants = cva(badgeClasses, {
	variants: {
		variant: {
			gray: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200',
			dark: 'bg-gray-500 dark:bg-gray-700 text-white dark:text-gray-100',
			red: 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300',
			orange: 'bg-orange-50 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300',
			yellow: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300',
			amber: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300',
			green: 'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300',
			blue: 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
			purple: 'bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300',
			emerald:
				'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300',
			teal: 'bg-teal-50 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300',
			indigo: 'bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300',
			lime: 'bg-lime-50 dark:bg-lime-900/30 text-lime-700 dark:text-lime-300',
			cyan: 'bg-cyan-50 dark:bg-cyan-900/30 text-cyan-700 dark:text-cyan-300',
			sky: 'bg-sky-50 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300',
			rose: 'bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-300',
		},
		effect: {
			inset: 'shadow-inset',
			none: '',
		},
	},
	defaultVariants: {
		variant: 'gray',
		effect: 'none',
	},
});

const Badge = React.forwardRef(
	({className, variant, effect, children, ...props}, ref) => {
		return (
			<div
				ref={ref}
				className={twMerge(badgeVariants({variant, effect, className}))}
				{...props}
			>
				{children}
			</div>
		);
	},
);

Badge.displayName = 'Badge';

export default Badge;
